
export type CancelEnrollmentByCourseId200Result = typeof CancelEnrollmentByCourseId200Result[keyof typeof CancelEnrollmentByCourseId200Result];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancelEnrollmentByCourseId200Result = {
  success: 'success',
} as const;
